// ModalComponent.js
import React from 'react';
import Modal from 'react-modal';
import '../App.css';


const InfoModal = ({ isOpen, closeModal, modalContent, headerContent }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
        >
            <div>
                <div className="modal-header">
                    <h2>{headerContent}</h2>
                    <button onClick={closeModal} className="close-modal-btn"><i class="fa-solid fa-xmark"></i></button>
                </div>

                {modalContent}
            </div>
        </Modal>
    );
};

export default InfoModal;
